var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.99992 3.2976L9.61157 6.56261C9.68434 6.71004 9.82493 6.81227 9.98761 6.83605L13.5924 7.36294L10.9844 9.90312C10.8664 10.018 10.8126 10.1836 10.8404 10.3458L11.4558 13.9338L8.23264 12.2388C8.08695 12.1621 7.91288 12.1621 7.76719 12.2388L4.54401 13.9338L5.15939 10.3458C5.18722 10.1836 5.13339 10.018 5.01545 9.90312L2.40746 7.36294L6.01223 6.83605C6.17491 6.81227 6.3155 6.71004 6.38827 6.56261L7.99992 3.2976Z","stroke":"#F3AD18"}));
}

Star.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = Star;

Star.default = Star;
